import Axios from 'axios';
import React, {Fragment, useEffect, useState} from 'react'
import Footer from '../footer';
import Header from './Headers'
import ApplyForJob from './ApplyForJob';
import Config from "../config/config";

const JobDescription = (props) => {
    const [jobDetails, setJobDetails] = useState([])
    const [jobPostId, setJobPostId] = useState('')

    useEffect(() => {
        let jobId = props.match.params.id;
        setJobPostId(jobId)
        Axios.get(`${Config.getJobUrl}${jobId}`)
            .then((response) => {
                setJobDetails(jobDetails => [...jobDetails, response.data]);
            }).catch((error) => {
            console.error('Error:', error);
        });
    }, [])
    console.log(jobDetails);
    if (!jobDetails) {
        return null;
    }


    let tableRows = jobDetails.map((element, index) => {
            return (<div className="col-md-12" key={index}>
                <p className='blue-colors content-info'><strong
                    className='Bussiness-plan-model'>Role:</strong> {element.job_description.role}</p>
                <p className='blue-colors content-info'><strong className='Bussiness-plan-model'>Reports
                    to:</strong> {element.job_description.reports_to} </p>
                <p className='blue-colors content-info'><strong className='Bussiness-plan-model'>Industry
                    Type:</strong> Fintech & Lending</p>
                <p className='blue-colors content-info'><strong className='Bussiness-plan-model'>Employment
                    Type:</strong> {element.job_description.employment_type}</p>
                <p className='blue-colors content-info'><strong className='Bussiness-plan-model'>Job
                    Location:</strong> {element.location}</p>
                <p className='blue-colors content-info'><strong
                    className='Bussiness-plan-model'>Joining:</strong> {element.job_description.joining}</p>
                <p className='blue-colors content-info'><strong
                    className='Bussiness-plan-model'>Education:</strong> {element.job_description.education}</p>
            </div>)
        }
    )

    let role_and_responsibilities = jobDetails.map((ele, index) => {
        return (

            <li key={index}>{ele.role_and_responsibilities}</li>

        )
    })
    let skills_and_experience = jobDetails.map((ele, index) => {
        return (

            <li key={index}>{ele.skills_and_experience}</li>

        )
    })

    return (
        <Fragment>
            <Header/>
            <section className="pdtb-20 breadcrumbs">
                <div className="container" data-aos="fade-up">
                    <div className='row'>
                        <div className='col-lg-6 col-sm-6 col-xs-6 job-description-title pt-3'>
                            <ol>
                                <li><a href="/">Home</a></li>
                                <li>JOB DESCRIPTION</li>
                            </ol>
                        </div>
                        <div className='col-lg-6 col-sm-6 col-xs-6 job-description-title'
                             style={{
                                 display: "flex",
                                 alignItems: "center",
                                 justifyContent: "end"
                             }}>
                            <button className='btn-hover'
                                    style={{
                                        cursor: "pointer",
                                        padding: "10px 30px",
                                        color: "white",
                                        background: "#EA7726",
                                        borderRadius: "7px",
                                        border: "none",

                                    }}><a href="#applynow">Apply Now</a></button>

                        </div>
                    </div>
                </div>
            </section>
            <section className='pt-60'>
                <div className='container'>
                    <div className="section-titles">
                        <h3 className="heading_tow">JOB DESCRIPTION</h3>
                    </div>

                    <div className="job-info">
                        <div className="row"
                             style={{
                                 lineHeight: 0.7,
                             }}>
                            {tableRows}
                        </div>
                    </div>
                    <div>
                        <h5
                            style={{
                                fontSize: "16px",
                                fontWeight: "600",
                                color: " #1e3056",
                                padding: "30px 0 12px 0"
                            }}>About Revfin</h5>
                        <p className='content-info'>Revfin (Revfin Services Private Limited) is an advanced Digital
                            Lending platform that provides
                            loans to individuals that are financially excluded. Revfin leverages techniques like
                            Biometrics,
                            Psychometrics and Gamification for assessing the credibility of a prospect before
                            sanctioning a
                            loan. Using such techniques with Artificial Intelligence algorithms reduces NPAs
                            significantly.
                            Revfin is present across 18 states with focus on financing electric vehicles.
                        </p>
                    </div>
                    <div>
                        <h5
                            style={{
                                fontSize: "16px",
                                fontWeight: "600",
                                color: " #1e3056",
                                padding: "30px 0 12px 0"
                            }}>Role and Responsibilities:</h5>
                        <ol className='skill-info'>
                            {role_and_responsibilities}
                        </ol>
                    </div>
                    <div>
                        <h5
                            style={{
                                fontSize: "16px",
                                fontWeight: "600",
                                color: " #1e3056",
                                padding: "30px 0 12px 0"
                            }}>Skills and Experience:</h5>
                        <ol className='skill-info'>
                            {skills_and_experience}

                        </ol>
                    </div>
                    <div>
                        <h5
                            style={{
                                fontSize: "16px",
                                fontWeight: "600",
                                color: " #1e3056",
                                padding: "30px 0 12px 0"
                            }}>What we offer:</h5>
                        <p className='content-info'>Competitive salary, Health Insurance, Personal Development
                            Allowance, Employee Loans etc.</p>
                    </div>
                    <div>
                        <h5
                            style={{
                                fontSize: "16px",
                                fontWeight: "600",
                                color: " #1e3056",
                                padding: "30px 0 12px 0"
                            }}>Why Join us</h5>
                        <p className='content-info' id="applynow">We’re building the foundation of our team right now
                            and are looking for ambitious team
                            members to join us and grow rapidly with us. The work environment is fast-paced, and you
                            would
                            make a clear impact!<br/>
                            We’re a well-funded start-up, which has raised capital from organization like Shell
                            Foundation.
                        </p>
                    </div>
                </div>

                <ApplyForJob
                    jobPostId={jobPostId}
                    job_ID={props.job_ID}
                />
            </section>
            <Footer/>
        </Fragment>
    )
}

export default JobDescription



// WEBPACK FOOTER //
// ./src/components/JobDescription.js